export enum Color {    
    Blue = "#01A9E0",
    LightBlue = "#EBFAFF",
    SharpBlue = "#A5E1F4",
    BlueYonder = "#4267B2",
    HonoluluBlue = "#0072B1",
    Green = "#51CB20",
    FreshGreen = "#ADEF87",
    LightGreen = "#C2EDB0",
    SharpGreen = "#DCF5D2",
    MintGreen = "#B5F09D",
    Ash = "#EAEAEB",    
    LightAsh = "#F4F4F4",
    MiddleAsh = "#D5D5D6",
    SharpAsh = "#909090",
    DeepAsh = "#515251",
    DarkAsh = "#DFDFDF",
    Gainsboro = "#DEDEDE",
    White = "#FFFFFF",
    Black = "#000000",
    LightBlack = "#3C3C3C",
    MiddleBlack = "#515151",
    DeepBlack = "#0B132B",
    Red = "#FB3640", 
    LightRed = "#F5D8DA",
    CoralRed = "#FB364019",
    DarkRed = "#C70E20",
    LoaderBackground = "#F3F3F3",
    LoaderForeground = "#ECEBEb",
    LightSilver = "#D6D5D6",
    DarkGray = "#707070",
    GraniteGray = "#5F5F5F",
    HarvestGold = "#E39500",
    MutedGold = "#EBCE95",
    MiddleGold = "#E3950026",
    LightGold = "#E3950019",
    ChampagneGold = "#F0D7A8",
    LightGray = "#D5D5D5",
    MiddleGray = "#999",
    Gray = "#D1D1D1",
    BrightGray = "#EAEAEB",
    Nyanza = "#E4F7DD",
    Cultured = "#F4F5F5",
    OldLace = "#FDF3E0",
    Munsell = "#00BE7E",
    Linen = "#FEEAEB",
    LightSliverGray = "#D9D9D9",
    FaluRed = "#8D1C15",
    Frostbite = "#DE39B0",
    MediumPurple = "#8E63DE",
    PurplePlum = "#9C52BA",
    RoseRed = "#B71E51",
    LightPink= "#FFF0F5",
    LightOrange = "#FFAA55",
    Canvas = "#F7F8FA"
}